import { useQuery } from '@apollo/client';
import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Box } from '@mui/material';

import { Query } from '@libs/graphql-types';

import { GET_STRIIVE_JOB_INFO } from '../job-v1/queries';
import { JobHeader } from './components/job-header';
import { JobTabs } from './components/job-tabs';
import { TabContent } from './components/tab-content';

interface JobV2Props extends RouteComponentProps<{ id: string }> {}

const POLL_INTERVAL = 2000;

export const JobV2Screen: React.FC<JobV2Props> = ({ match }) => {
  const { id } = match.params;
  const { data, loading, refetch } = useQuery<Query>(GET_STRIIVE_JOB_INFO, {
    variables: { id },
    nextFetchPolicy: 'network-only',
    fetchPolicy: 'network-only',
    pollInterval: POLL_INTERVAL,
  });
  const job = data?.job;

  return (
    <ConnectedPageLayout
      documentTitle="Job Details"
      headerProps={{ accountProps: {} }}
      drawerProps={{}}
      isLoading={loading}
    >
      <Box>
        <JobHeader jobData={job} refetch={refetch} />
        {job && <JobTabs jobId={job.id} />}
        <TabContent jobData={job} />
      </Box>
    </ConnectedPageLayout>
  );
};
